import PortableText from "@/components/sanity/PortableText.vue";

// Text section

export default {
  name: "PostSection1",
  components: {
    PortableText: PortableText
  },
  props: {
    sectionData: {
      type: Object,
      required: true
    }
  }
};